
import * as React from "react"
import { StrokeProps } from "react-native-svg"

interface RuneInput {
    color: string
    strokeSize: string
    width: string
    height: string

    vowel?: string
    consonant?: string
    dot?: boolean
}

interface ControlRods {
    [key: string]: number
}

interface Phonetics {
    [key: string]: Array<string>
}


export default function Rune(input: RuneInput) {

    let controlRods: ControlRods = {
        "m-r-v-1": 1,
        "m-l-v-1": 1,
        "u-r-d-1": 0,
        "u-r-u-1": 0,
        "u-m-v-2": 0,
        "u-l-d-1": 0,
        "u-l-u-1": 0,
        "u-l-v-1": 0,
        "d-r-d-1": 0,
        "d-r-u-1": 0,
        "d-m-v-1": 0,
        "d-l-u-1": 0,
        "d-l-d-1": 0,
        "d-l-v-1": 0,
        "u-m-v-1": 0,
        "crl": 0
    }
    if (input.dot) controlRods["crl"] = 1

    let phonetics: Phonetics = {
        "aa": ["u-l-d-1", "u-l-v-1", "d-l-v-1"],
        "ae": ["u-l-d-1", "u-r-d-1", "u-l-v-1", "d-l-v-1"],
        "ah": ["u-l-d-1", "u-r-d-1"],
        "ao": ["u-l-d-1", "u-l-v-1", "d-l-v-1"],
        "aw": ["d-r-u-1"],
        "ay": ["u-r-d-1"],
        "b": ["u-m-v-1", "u-m-v-2", "d-r-d-1"],
        "ch": ["u-m-v-2", "u-l-u-1", "d-m-v-1"],
        "d": ["u-m-v-1", "u-m-v-2", "d-l-d-1", "d-r-d-1"],
        "dh": ["u-m-v-1", "u-m-v-2", "d-m-v-1", "d-l-d-1", "d-r-d-1"],
        "eh": ["u-l-v-1", "d-l-v-1", "d-l-u-1", "d-r-u-1"],
        "er": ["u-l-v-1", "d-l-v-1", "u-r-d-1", "d-l-u-1", "d-r-u-1"],
        "ey": ["u-l-d-1"],
        "f": ["u-m-v-2", "u-r-u-1", "d-l-d-1", "d-m-v-1"],
        "g": ["u-m-v-2", "u-r-u-1", "d-r-d-1", "d-m-v-1"],
        "hh": ["u-m-v-1", "u-m-v-2", "d-m-v-1", "d-r-d-1"],
        "ih": ["d-l-u-1", "d-r-u-1"],
        "iy": ["u-l-v-1", "u-l-d-1", "d-l-v-1", "d-l-u-1", "d-r-u-1"],
        "jh": ["u-m-v-1", "u-m-v-2", "d-l-d-1"],
        "k": ["u-m-v-1", "u-m-v-2", "u-r-u-1", "d-r-d-1"],
        "l": ["u-m-v-1", "u-m-v-2", "d-m-v-1"],
        "m": ["d-l-d-1", "d-r-d-1"],
        "n": ["d-l-d-1", "d-r-d-1", "u-l-u-1"],
        "ng": ["u-m-v-1", "u-m-v-2", "u-l-u-1", "u-r-u-1", "d-m-v-1", "d-l-d-1", "d-r-d-1"],
        "ow": ["u-l-v-1", "u-l-d-1", "u-r-d-1", "d-l-v-1", "d-l-u-1", "d-r-u-1"],
        "oy": ["d-l-u-1"],
        "p": ["u-m-v-2", "u-r-u-1", "d-m-v-1"],
        "r": ["u-m-v-1", "u-m-v-2", "u-r-u-1", "d-m-v-1"],
        "s": ["u-m-v-1", "u-m-v-2", "u-r-u-1", "d-m-v-1", "d-l-d-1"],
        "sh": ["u-m-v-2", "u-l-u-1", "u-r-u-1", "d-m-v-1", "d-l-d-1", "d-r-d-1"],
        "t": ["u-m-v-2", "u-l-u-1", "u-r-u-1", "d-m-v-1"],
        "th": ["u-m-v-1", "u-m-v-2", "u-l-u-1", "u-r-u-1", "d-m-v-1"],
        "uh": ["u-l-v-1", "d-l-v-1", "d-l-u-1"],
        "uw": ["u-l-v-1", "u-l-d-1", "u-r-d-1", "d-l-v-1", "d-l-u-1"],
        "v": ["u-m-v-1", "u-m-v-2", "u-l-u-1", "d-r-d-1"],
        "w": ["u-l-u-1", "u-r-u-1"],
        "y": ["u-m-v-1", "u-m-v-2", "u-l-u-1", "d-m-v-1"],
        "z": ["u-m-v-1", "u-m-v-2", "u-l-u-1", "d-m-v-1", "d-r-d-1"],
        "zh": ["u-m-v-1", "u-m-v-2", "u-l-u-1", "u-r-u-1", "d-l-d-1", "d-r-d-1"],
    }

    phonetics[input.vowel || ""]?.forEach(element => controlRods[element] = 1);
    phonetics[input.consonant || ""]?.forEach(element => controlRods[element] = 1);

    return <svg
        width={input.width}
        height={input.height}
        viewBox="0 0 37.877319 72.910782"
        version="1.1"
        id="svg1"
        xmlns="http://www.w3.org/2000/svg">
        <defs id="defs1" />
        <g id="layer1" transform="translate(-237.04461,-224.09975)">
            <path
                style={{ fill: "none", stroke: input.color, strokeWidth: input.strokeSize, strokeLinecap: "round", strokeLinejoin: "round", strokeOpacity: controlRods["m-r-v-1"] }}
                d="m 255.98327,256 h 18.43866"
                id="m-r-v-1" />
            <path
                style={{ fill: "none", stroke: input.color, strokeWidth: input.strokeSize, strokeLinecap: "round", strokeLinejoin: "round", strokeOpacity: controlRods["m-l-v-1"] }}
                d="m 237.54461,256 h 18.43866"
                id="m-l-v-1" />
            <path
                style={{ fill: "none", stroke: input.color, strokeWidth: input.strokeSize, strokeLinecap: "round", strokeLinejoin: "round", strokeOpacity: controlRods["u-r-d-1"] }}
                d="m 273.85516,234.59343 -17.86352,-9.99368"
                id="u-r-d-1" />
            <path
                style={{ fill: "none", stroke: input.color, strokeWidth: input.strokeSize, strokeLinecap: "round", strokeLinejoin: "round", strokeOpacity: controlRods["u-r-u-1"] }}
                d="m 256,244.90211 17.85516,-10.30868"
                id="u-r-u-1" />
            <path
                style={{ fill: "none", stroke: input.color, strokeWidth: input.strokeSize, strokeLinecap: "round", strokeLinejoin: "round", strokeOpacity: controlRods["u-m-v-2"] }}
                d="M 255.98327,256 256,244.90211"
                id="u-m-v-2" />
            <path
                style={{ fill: "none", stroke: input.color, strokeWidth: input.strokeSize, strokeLinecap: "round", strokeLinejoin: "round", strokeOpacity: controlRods["u-l-d-1"] }}
                d="m 237.54461,234.59232 18.44703,-9.99257"
                id="u-l-d-1" />
            <path
                style={{ fill: "none", stroke: input.color, strokeWidth: input.strokeSize, strokeLinecap: "round", strokeLinejoin: "round", strokeOpacity: controlRods["u-l-u-1"] }}
                d="M 256,244.90211 237.54461,234.59232"
                id="u-l-u-1" />
            <path
                style={{ fill: "none", stroke: input.color, strokeWidth: input.strokeSize, strokeLinecap: "round", strokeLinejoin: "round", strokeOpacity: controlRods["u-l-v-1"] }}
                d="M 237.54461,234.59232 V 256"
                id="u-l-v-1" />
            <path
                style={{ fill: "none", stroke: input.color, strokeWidth: input.strokeSize, strokeLinecap: "round", strokeLinejoin: "round", strokeOpacity: controlRods["d-r-d-1"] }}
                d="M 274.42193,277.33829 256,266.79058"
                id="d-r-d-1" />
            <path
                style={{ fill: "none", stroke: input.color, strokeWidth: input.strokeSize, strokeLinecap: "round", strokeLinejoin: "round", strokeOpacity: controlRods["d-r-u-1"] }}
                d="m 256,287.48947 18.42193,-10.15118"
                id="d-r-u-1" />
            <path
                style={{ fill: "none", stroke: input.color, strokeWidth: input.strokeSize, strokeLinecap: "round", strokeLinejoin: "round", strokeOpacity: controlRods["d-m-v-1"] }}
                d="m 256,266.79058 v 20.69889"
                id="d-m-v-1" />
            <path
                style={{ fill: "none", stroke: input.color, strokeWidth: input.strokeSize, strokeLinecap: "round", strokeLinejoin: "round", strokeOpacity: controlRods["d-l-u-1"] }}
                d="M 237.54461,277.13201 256,287.48947"
                id="d-l-u-1" />
            <path
                style={{ fill: "none", stroke: input.color, strokeWidth: input.strokeSize, strokeLinecap: "round", strokeLinejoin: "round", strokeOpacity: controlRods["d-l-d-1"] }}
                d="m 256,266.79058 -18.45539,10.34143"
                id="d-l-d-1" />
            <path
                style={{ fill: "none", stroke: input.color, strokeWidth: input.strokeSize, strokeLinecap: "round", strokeLinejoin: "round", strokeOpacity: controlRods["d-l-v-1"] }}
                d="m 237.54461,266.35439 v 10.77762"
                id="d-l-v-1" />
            <path
                style={{ fill: "none", stroke: input.color, strokeWidth: input.strokeSize, strokeLinecap: "round", strokeLinejoin: "round", strokeOpacity: controlRods["u-m-v-1"] }}
                d="M 255.99164,224.59975 256,244.90211"
                id="u-m-v-1" />
            <ellipse
                style={{ fill: "none", stroke: input.color, strokeWidth: input.strokeSize, strokeLinecap: "round", strokeLinejoin: "round", strokeOpacity: controlRods["crl"], strokeMiterlimit: "2.1", strokeDasharray: "none" }}
                id="crl"
                cx="256"
                cy="292"
                rx="4.5430002"
                ry="4.51053" />
        </g>
    </svg>
}